import { fetchData } from 'services/fetchData';

import { authStore, reportStore } from 'stores';

/**
 * Function to retrieve all SObjects from a Salesforce org.
 * @returns
 */
export const getSObjects = async () => {
    const { jwtToken } = authStore.getState('passwordSession').value.sessionDetails;
    const organization = reportStore.getState('currentOrg').value;

    const httpOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwtToken}`
        },
        withCredentials: true
    };

    // All other quries
    const { data, response } = await fetchData(`/salesforce/sobjects/${organization._id}`, httpOptions);
    return { data, response };
};
